import type { RslDimension } from '@features/campaigns/subdomains/rsl';
import { TOTAL_DIMENSIONS } from '@features/executive-report/dimensions/layout';
import type { RslDimensionSlug } from '../constants/dimensions';

type SignificantDimensionFields = Pick<
  RslDimension,
  'dimensionName' | 'statisticallySignificant' | 'incrementalSalesLift'
>;

const isSignificantDimension = (
  dimension: SignificantDimensionFields,
  dimensionName: RslDimensionSlug
) =>
  dimension.dimensionName === dimensionName &&
  dimension.statisticallySignificant;

export const countSignificantDimensions = (
  dimensions: SignificantDimensionFields[],
  dimensionName: RslDimensionSlug
) => dimensions.filter(d => isSignificantDimension(d, dimensionName)).length;

export const topSignificantDimensions = <T extends SignificantDimensionFields>(
  dimensions: T[],
  dimensionName: RslDimensionSlug
) =>
  dimensions
    .filter(d => isSignificantDimension(d, dimensionName))
    .toSorted(
      (a, b) => (b.incrementalSalesLift ?? 0) - (a.incrementalSalesLift ?? 0)
    )
    .slice(0, TOTAL_DIMENSIONS);
